// AUTO-GENERATED by scripts/gen-build-info.js — do not edit by hand.
export const BUILD_INFO = {
  commit: "9f2e3e3",
  branch: "HEAD",
  buildTime: "2026-11-04T06:35:30.983Z",
} as const;
